import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { createGlobalStyle } from "styled-components"
import P from '../pages';
import { useSelector, useDispatch } from 'react-redux';
import Redirector from '../routes/Redirector';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col'
import Styles from "../../../shared/components/styled/Address.styles"
import { setAddress as setAddressAction } from '../../../shared/actions';
import { defaultMessages } from '../../../libs/i18n/default';
import { injectIntl } from 'react-intl';

const GlobalStyle = createGlobalStyle`
  @media (min-width: 768px) {
    #guest_signup>.container {
      width: 600px;
    }
    #guest_signup>.container>.panel {
      border-radius: 12px;
    }
  }
`

const Address = ({ intl }) => {
  const dispatch = useDispatch()
  const page = useSelector(state => state.page)
  const {
    address_redirect_url: redirectUrl,
    country_code: countryCode,
    transaction_email: transactionEmail,
    code,
    address_logo_srsc,
    address_logo_usa,
  } = useSelector(state => state.territory)
  const [address, setAddress] = useState({})

  const handleAddressSearch = async(address) => {
    if (address.google) {
      const response = await fetch(`/places/details_from_google?gmaps_id=${address.value}`)
      const data = await response.json()

      address.state = data.state_code
    }
    setAddress(address)
  }

  useEffect(() => {
    $('#addressSearch').autocomplete({
      source: "/places/autocomplete_with_google?address_page=true",
      minLength: 2,
      autoFocus: true,
      delay: 300,
      select: function(e,ui){
        e.preventDefault();
        $(addressSearch).blur();
        addressSearch.value = ui.item.label;
        handleAddressSearch(ui.item);
      },
      focus: function(e,ui){
        e.preventDefault();
      }
    })
  }, [])

  const submit = () => {
    let params = new URLSearchParams(window.location.search)
    params.append('place_id', address.value)
    params.append('place_name', address.label)
    params.append('place_from_google', address.google)
    let californiaAddress = address.state == 'CA' || address.state == 'California'
    let redirect = (
      (californiaAddress && code != 'SRSC') ||
      (!californiaAddress && code == 'SRSC')
    )
    if (!redirect) {
      dispatch(setAddressAction(address))
    } else {
      let uri = `${redirectUrl}/guests/signup${params.toString() && `?${params.toString()}`}`
      window.location = encodeURI(uri)
    }
  }

  const pageValid = () => address.value && address.state

  return (
    <Styles.AddressContainer>
      <GlobalStyle />
      <Redirector this_page={P.ADDRESS_PAGE} page={page}/>
      <Styles.Row>
        <Col lg={11}>
          <div className="text-center">
            <Styles.Logo src={address_logo_srsc} alt="StudentRoomStayConcierge Logo" />
            <Styles.Logo src={address_logo_usa} alt="AHN USA Logo" />
          </div>
          <Styles.Title>{intl.formatMessage(defaultMessages.clientGuestPagesAddressTitle)}</Styles.Title>
          <Styles.SubTitle>{intl.formatMessage(defaultMessages.clientGuestPagesAddressSubtitle)}</Styles.SubTitle>
          <Styles.Seperator />
          <Styles.Help>{intl.formatMessage(defaultMessages.clientGuestPagesAddressHelptext)}</Styles.Help>
          <FormGroup>
            <Styles.Search onChange={() => setAddress({})} />
          </FormGroup>
        <Styles.Submit
          disabled={!pageValid()}
          onClick={submit}>Continue</Styles.Submit>
        </Col>
      </Styles.Row>
    </Styles.AddressContainer>
  )
}

export default injectIntl(Address)
